import { Tooltip } from 'antd';
import { useAuth } from '../Auth/store';
import { useChartComparison } from './comparison.store';
import { ReactComponent as IcoChartComparison } from '../../images/ico_chart_comparison.svg';
import References from '../../helpers/Reference';

export const ComparisonMapControl = ({ startPos }) => {
    const permission = useAuth((state) => state.permission);
    const channels = useChartComparison((state) => state.channels);
    const openComparison = useChartComparison((state) => state.openComparison);
    const clearChannels = useChartComparison((state) => state.clearChannels);

    if (!permission?.permissions?.can_view_tech_data)
        return null;

    return (
        <div className="left-menu-items comparison-map-control-position" style={{ top: `${startPos + 180}px` }}>
            <div className="comparison-map-control">
                <Tooltip 
                    title="К сравнению"             
                    placement="left" 
                    color="white" 
                    overlayInnerStyle={{color: "black"}}
                    mouseEnterDelay={References.tooltip_delay}
                >
                    <span>
                        <button
                            type="button"
                            className="position-absolute-btn circle md comparison-map-button"
                            onClick={openComparison}
                            disabled={channels.length === 0}
                            aria-label="К сравнению"
                        >
                            <IcoChartComparison aria-hidden="true" focusable="false" />
                            <span className="comparison-map-count">{channels.length}</span>
                        </button>
                    </span>
                </Tooltip>
                {channels.length > 0 && (
                    <Tooltip title="Очистить выбранные каналы" placement="left">
                        <button
                            type="button"
                            className="comparison-map-clear"
                            onClick={clearChannels}
                            color="white" 
                            overlayInnerStyle={{color: "black"}}
                            mouseEnterDelay={References.tooltip_delay}
                            aria-label="Очистить выбранные каналы сравнения"
                        >
                            ×
                        </button>
                    </Tooltip>
                )}
            </div>
        </div>
    );
};